var chunkToChildrenMap = {
	"7312": [
		184,
		6235,
		8639,
		6582,
		6163,
		2531,
		5200,
		6609,
		3389
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));